import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { createCompGiftPass } from '../../api/gift-pass-actions';

import {
  actionErrorMessage,
  validateCompForm,
  type CompFormErrors,
  type CompFormValues,
} from './gift-pass-actions-model';
import { giftPassPath } from './gift-passes-model';

const EMPTY: CompFormValues = { purchaserEmail: '', reason: '' };

export function useGiftPassComp() {
  const navigate = useNavigate();
  const [values, setValues] = useState(EMPTY);
  const [errors, setErrors] = useState<CompFormErrors>({});
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const set = (key: keyof CompFormValues) => (value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    const found = validateCompForm(values);
    setErrors(found);
    setSubmitError(null);
    if (Object.keys(found).length > 0) return;
    setSubmitting(true);
    try {
      const giftPass = await createCompGiftPass({
        purchaserEmail: values.purchaserEmail.trim(),
        reason: values.reason.trim(),
      });
      navigate(giftPassPath(giftPass.id));
    } catch (err) {
      setSubmitError(
        actionErrorMessage(err, 'Something went wrong and the comp pass was not created.'),
      );
      setSubmitting(false);
    }
  };

  return { values, errors, submitError, submitting, set, submit };
}
